import { useState } from "react";
import type { FormEvent } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { login } from "../api/auth";
import { useAuthStore } from "../store/auth";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const setUser = useAuthStore((s) => s.setUser);
  const nav = useNavigate();
  const loc = useLocation() as { state?: { from?: string } };

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const user = await login(email, password);
      setUser(user);
      nav(loc.state?.from || "/", { replace: true });
    } catch (err: any) {
      setError(err?.response?.data?.detail || "No pudimos iniciar sesión.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-shell">
      <form className="auth-card" onSubmit={onSubmit}>
        <h1>Videotool</h1>
        <p className="subtitle">Edita vídeos en castellano, fácil.</p>

        <div className="field">
          <label className="label" htmlFor="email">Email</label>
          <input id="email" type="email" autoComplete="email" required
                 value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="field">
          <label className="label" htmlFor="password">Contraseña</label>
          <input id="password" type="password" autoComplete="current-password" required
                 value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>

        {error && <div className="error-text">{error}</div>}

        <button type="submit" className="primary" disabled={loading} style={{ width: "100%" }}>
          {loading ? "Entrando…" : "Entrar"}
        </button>

        <p style={{ marginTop: 20, fontSize: 12, color: "var(--text-dim)" }}>
          El acceso es por invitación. Si recibiste un email, abre el enlace que te llegó.
        </p>
      </form>
    </div>
  );
}
